<template>
  <div class="headermain">
    <div class="toptxt">
      <div class="weather">
        <span>{{ weatherdata.weather }} {{ weatherdata.temp }}℃</span>
        {{ time }}
      </div>
      <div class="user" @click="toggleUserMenu">
        <i class="el-icon-user-solid"></i> <span>{{ userInfo.nickName }}</span>
        <i class="el-icon-arrow-down"></i>
        <div class="menubox" v-show="showUserMenu">
          <div class="menubtn" @click.stop="goManagementPage" need-listen data-event-name="goManagementPage">管理后台</div>
          <div class="menubtn" @click.stop="logout" need-listen data-event-name="logout">退出登录</div>
        </div>
      </div>
    </div>
    <div class="topbox">
      <div class="leftbtnbox">
        <div
          class="btnitem"
          :class="{ btnitemed: activeMenu === 'workbench' }"
          need-listen
          data-event-name="goWorkbench"
          @click="gopage('/workbench')"
        >
          智能工作台
        </div>
        <div
          class="btnitem"
          :class="{ btnitemed: activeMenu === 'breakingNews' }"
          need-listen
          data-event-name="goBreakingNews"
        >
          莓市速报
        </div>
      </div>
      <div class="title">赣南龍莓智慧管理平台</div>
      <div class="rightbtnbox">
        <div class="btnitem" :class="{ btnitemed: activeMenu === 'monitor' }" >
          智能监控
          <div class="menubox">
            <div class="menubtn" @click="gopage('/')" need-listen data-event-name="goDataMonitor">数据监测</div>
            <div
              class="menubtn"
              v-if="getAllMenuCodes.includes('NxAESe5c')"
              @click="gopage('/data')" need-listen data-event-name="goDataCenter"
            >
              数据中心
            </div>
            <div
              class="menubtn"
              v-if="getAllMenuCodes.includes('Rx58QlCS')"
              @click="gopage('/camera')" need-listen data-event-name="goRealTimeMonitor"
            >
              实时监控
            </div>
          </div>
        </div>
        <div class="btnitem" :class="{ btnitemed: activeMenu === 'farming' }" >
          数字农事
          <div class="menubox">
            <div
              class="menubtn"
              v-if="getAllMenuCodes.includes('KJt09jUE')"
              @click="gopage('/techFarm/tesk')" need-listen data-event-name="goTechFarmTask"
            >
              农事调度
            </div>
            <div
              class="menubtn"
              v-if="getAllMenuCodes.includes('jCBVoAzk')" 
              @click="gopage('/techFarm/history')" need-listen data-event-name="goTechFarmHistory"
            >
              农事记录
            </div>
            <div
              class="menubtn"
              v-if="getAllMenuCodes.includes('cv7hGmeL')"
              @click="gopage('/techFarm/harvest/index')" need-listen data-event-name="goTechFarmHarvest"
            >
              产品采收
            </div>
            <!-- <div class="menubtn" v-if="getAllMenuCodes.includes('Rx58QlCS')" @click="gopage('/techFarm/guide')">种植指南 -->
          </div>
        </div>
        <div class="btnitem" @click="openDispatchCenter" need-listen data-event-name="goDispatchCenter">调度中心</div>
      </div>
    </div>
    <Logo />
  </div>
</template>

<script>
import router from "../router";
import axios from "axios";
import Logo from "./Logo.vue";
import { mapState, mapGetters } from "vuex";
import { getweatherdata } from "@/api/bot";
export default {
  name: "index",
  components: {
    Logo,
  },
  data() {
    return {
      weatherdata: [],
      time: "",
      showUserMenu: false,
      drawer: false,
    };
  },
  computed: {
    ...mapState("user", ["userInfo", "menu"]),
    ...mapGetters("user", ["getAllMenuCodes"]),
    // 根据当前路由判断激活哪个tab
    activeMenu() {
      const currentPath = this.$route.path;
      console.log("当前路由", currentPath);
      // 智能监控相关路由
      if (["/", "/data", "/camera"].includes(currentPath)) {
        return "monitor";
      }
      // 工作台
      if (
        currentPath.startsWith("/workbench") ||
        currentPath.startsWith("/actionLog")
      ) {
        return "workbench";
      }
      // 数字农事相关路由
      if (currentPath.startsWith("/techFarm/")) {
        return "farming";
      }

      // 管理后台相关路由
      if (currentPath.startsWith("/management")) {
        return "management";
      }
      // 莓市速报相关路由
      if (currentPath.startsWith("/breakingNews")) {
        console.log("莓市速报");
        return "breakingNews";
      }
      // 默认返回monitor
      return "monitor";
    },
    isDev() {
      const roleIds = this.userInfo.roleIds.split(",");
      return roleIds.includes("1");
    },
  },
  mounted() {
    this.getcitydata();
    this.gettime();
    // 添加全局点击事件监听
    document.addEventListener("click", this.closeUserMenu);
  },
  beforeDestroy() {
    // 移除全局点击事件监听
    document.removeEventListener("click", this.closeUserMenu);
  },
  methods: {
    toBreakingNews() {
      if (this.getAllMenuCodes.includes("M44W1hVz")) {
        this.$router.push("/breakingNews");
      } else {
        this.$message.error("您没有权限访问此页面");
      }
    },
    toggleUserMenu(e) {
      console.log(e);

      e.stopPropagation();
      this.showUserMenu = !this.showUserMenu;
    },
    closeUserMenu() {
      this.showUserMenu = false;
    },
    handleClose() {
      this.drawer = false;
    },
    gopage(e) {
      router.push(e);
    },
    goManagementPage() {
      if (this.getAllMenuCodes.includes("4ZJYxKnW")) {
        if (this.isDev) {
          this.$router.push("/management/menu");
        } else if (this.getAllMenuCodes.includes("hYs7xhSl")) {
          this.$router.push("/management/roles");
        } else if (this.getAllMenuCodes.includes("4rhW8qOe")) {
          this.$router.push("/management/accounts");
        }
      } else {
        this.$message.error("您没有权限访问此页面");
      }
    },
    getcitydata() {
      getweatherdata().then((res) => {
        console.log(res);
        this.weatherdata = res.data.real;
      });
    },
    gettime() {
      const date = new Date();
      const d = date.getDate().toString().padStart(2, "0");
      const m = (date.getMonth() + 1).toString().padStart(2, "0");
      const y = date.getFullYear();
      const h = date.getHours();
      const min = date.getMinutes();
      const weekdays = [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ];
      const w = weekdays[date.getDay()];
      this.time = `${y}年${m}月${d}日 ${h}:${min} ${w}`;
    },
    logout() {
      this.$store.commit("user/updateUserInfo", null);
      this.$router.push("/login");
      this.$store.commit("farm/setGreenhouseOptions", []);
      this.$store.commit("farm/setVarietyOptions", []);
      this.$store.commit("farm/setStageOptions", []);
    },
    openDispatchCenter() {
      if (!this.getAllMenuCodes.includes("Y1JTrlut")) {
        return this.$message.error("您没有权限访问此页面");
      }
      const url = process.env.VUE_APP_BIGDATA_URL;
      if (url) {
        window.open(`http://${url}`, "_blank");
      } else {
        window.open(
          `http://whiteStrawberry-big-screen.web.guanyingis.com`,
          "_blank"
        );
      }
    },
  },
};
</script>

<style scoped lang="less">
@font-face {
  font-family: "title";
  src: url("../assets/font/title.ttf");
}

.headermain {
  width: 100%;
  height: 78px;
  position: relative;
  z-index: 100;

  .toptxt {
    position: absolute;
    width: 100%;
    padding: 10px;
    display: flex;
    justify-content: space-between;
    z-index: 99;

    .weather {
      color: #ffffffc7;
      font-size: 14px;
      pointer-events: none;

      span {
        padding: 2px 20px;
        padding-left: 10px;
        border-right: 1px solid #ffffffc7;
        margin-right: 20px;
      }
    }

    .user {
      color: #ffffffc7;
      font-size: 16px;
      cursor: pointer;
      position: relative;
      pointer-events: auto;

      span {
        margin: 0 6px;
      }

      .menubox {
        position: absolute;
        right: 0px;
        top: 30px;
        width: 120px;
        background-color: #030f29;
        border: 1px solid rgba(99, 169, 255, 0.5);
        border-radius: 4px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
        z-index: 1000;

        .menubtn {
          padding: 12px 16px;
          text-align: center;
          font-size: 14px;
          color: #fff;
          cursor: pointer;
          border-bottom: 1px solid rgba(99, 169, 255, 0.2);

          &:last-child {
            border-bottom: none;
          }

          &:hover {
            background-color: #0389f8;
          }
        }
      }

      img {
        width: 150px;
        margin-top: 20px;
        position: fixed;
        right: 0px;
        top: 19px;
        z-index: 9;
      }
    }
  }

  .topbox {
    width: 100%;
    height: 78px;
    display: flex;
    justify-content: center;
    background-image: url("../assets/img/home/topbg.png");
    background-size: 100% 100%;

    .leftbtnbox {
      width: 600px;
      height: 60px;
      background-image: url("../assets/img/home/leftbtnbg.png");
      background-size: 100% 100%;
      margin-top: 10px;
      justify-content: flex-end;
      padding: 5px;
      padding-right: 40px;

      .btnitem {
        cursor: pointer;
        background-image: url("../assets/img/home/leftbtn.png");
        background-size: 100% 100%;
      }

      .btnitemed {
        background-image: url("../assets/img/home/leftbtned.png");
        background-size: 100% 100%;
      }
    }

    .title {
      width: 23%;
      height: 60px;
      font-size: 28px;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      letter-spacing: 3px;
    }

    .rightbtnbox {
      width: 600px;
      height: 60px;
      background-image: url("../assets/img/home/rightbtnbg.png");
      background-size: 100% 100%;
      margin-top: 10px;
      justify-content: flex-start;
      padding: 5px;
      padding-left: 15px;

      .btnitem:hover {
        .menubox {
          display: block;
        }
      }

      .btnitem {
        background-image: url("../assets/img/home/rightbtn.png");
        background-size: 100% 100%;
        cursor: pointer;
        position: relative;

        .menubox:hover {
          display: block;
        }

        .menubox {
          position: absolute;
          left: 0px;
          width: 150px;
          top: 100%;
          background-color: #030f29;
          border-bottom: 0;
          color: #fff;
          display: none;
          z-index: 1000;
          box-shadow: inset 0px -5px 11px 0px #0057c1;
          border-radius: 0px 0px 0px 0px;
          border: 1px solid;
          border-image: linear-gradient(
              180deg,
              rgba(99, 169, 255, 0),
              rgba(99, 169, 255, 1)
            )
            1 1;

          .menubtn {
            padding: 15px;
            text-align: center;

            font-size: 16px;
            font-weight: bold;
          }

          .menubtn:hover {
            background-color: #0389f8;
            color: #fff;
          }
        }
      }

      .btnitemed {
        background-image: url("../assets/img/home/rightbtned.png");
        background-size: 100% 100%;
      }
    }

    .leftbtnbox,
    .rightbtnbox {
      display: flex;

      .btnitem {
        font-size: 20px;
        color: #fff;
        width: 170px;
        height: 40px;
        margin: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>
